import { RouteProp, useNavigation, useRoute } from '../../../navigation/native';
import React from 'react';
import { useDispatch } from 'react-redux';

import { RootStackParamList } from '../../../app/Navigation';
import { editingActions, selectShiftLogDetails } from '../../../store';
import { AppDispatch } from '../../../store/store';
import { findGroupSnippet, navigateToSnippet } from '../helpers';
import Layout from '../Layout';
import Link from '../Link';

const GroupScreen = () => {
  const navigation = useNavigation();
  const { params } = useRoute<RouteProp<RootStackParamList, 'EditingGroupScreen'>>();
  const dispatch = useDispatch<AppDispatch>();

  const shiftLogDetails = selectShiftLogDetails.useHook();

  const [, snippet] = findGroupSnippet(params, shiftLogDetails.snippets);
  const items = snippet.groupSnippets.map((s) => s.displayName);

  const handleLinkPressed = (index: number) => {
    const groupIndex =
      typeof params.groupIndex !== 'undefined' ? params.groupIndex.concat(index) : [index];
    const s = snippet.groupSnippets[index];
    const p = { ...params, groupIndex, lastLink: items[index] };

    dispatch(editingActions.editedSnippetChanged(s));
    navigateToSnippet(navigation, s, p);
  };

  return (
    <Layout
      title={params.lastLink}
      content={
        <>
          {items.map((item, index) => (
            <Link key={index} name={item} handlePress={() => handleLinkPressed(index)} />
          ))}
        </>
      }
    />
  );
};

export default GroupScreen;
